<div class="share-modal">
    <button type="button" class="share-modal__close" aria-label="Close share modal" (click)="onClose()">
        <svg-icon icon="close"></svg-icon>
    </button>

    <div class="share-modal__header">
        <div class="share-modal__icon" aria-hidden="true">
            <svg-icon icon="share"></svg-icon>
        </div>
        <h2 class="share-modal__title">
            <span translate>share.shareWith</span>
            <span translate>{{ modalContent.to }}</span>
        </h2>
        <p class="share-modal__intro" translate>{{ modalContent.content }}</p>
    </div>

    <form class="share-modal__form" novalidate [formGroup]="shareForm" (ngSubmit)="doSave()">
        <div class="app-c-form-group">
            <label class="app-c-form--label" for="email" translate>share.email</label>
            <input
                class="app-c-form-control"
                type="email"
                formControlName="Email"
                id="email"
                #emailInput />
            <div class="error-message" *ngIf="isSubmitted && shareForm.get('Email').hasError('required')" translate>
                share.emailField
            </div>
            <div class="error-message" *ngIf="isSubmitted && shareForm.get('Email').hasError('email')" translate>
                share.validEmail
            </div>
        </div>

        <div class="app-c-form-group">
            <label class="app-c-form--label" for="message" translate>share.message</label>
            <textarea
                class="app-c-form-control share-modal__textarea"
                [attr.aria-label]="'share.message' | translate"
                id="message"
                rows="4"
                formControlName="Message"></textarea>
        </div>

        <div class="share-modal__footer">
            <button type="submit"
                class="app-c-btn app-c-btn--primary app-c-btn--curve share-modal__submit">
                <span translate>share.help</span>
                <span translate>{{ modalContent.to }}</span>
            </button>
        </div>
    </form>
</div>
